import { AlertTriangle, Building2, CalendarClock, Users } from "lucide-react"

import { StatCard, StatGrid } from "@/components/superadmin/kit"
import { useSuperAdminStats } from "@/hooks/useSuperAdminStats"

export const SuperAdminStats = () => {
  const { data: stats, isLoading } = useSuperAdminStats()
  const v = (n?: number) => (isLoading ? "—" : n ?? 0)

  return (
    <StatGrid>
      <StatCard
        label="Usuários ativos"
        value={v(stats?.active_users)}
        hint={`${stats?.new_users_month ?? 0} novos nos últimos 30 dias`}
        icon={Users}
        tone="accent"
      />
      <StatCard
        label="Organizações ativas"
        value={v(stats?.active_condominiums)}
        hint={`de ${stats?.total_condominiums ?? 0} cadastradas`}
        icon={Building2}
        tone="neutral"
      />
      <StatCard
        label="Pagamentos em atraso"
        value={v(stats?.overdue_condominiums)}
        hint={stats?.overdue_condominiums ? "Requer acompanhamento" : "Nenhuma inadimplência"}
        hintTone={stats?.overdue_condominiums ? "danger" : "success"}
        icon={AlertTriangle}
        tone={stats?.overdue_condominiums ? "danger" : "neutral"}
      />
      <StatCard
        label="Vencendo em 30 dias"
        value={v(stats?.expiring_soon)}
        hint={stats?.expiring_soon ? "Planeje as renovações" : "Sem renovações próximas"}
        hintTone={stats?.expiring_soon ? "warning" : undefined}
        icon={CalendarClock}
        tone={stats?.expiring_soon ? "warning" : "neutral"}
      />
    </StatGrid>
  )
}

export default SuperAdminStats
